import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  quotes: [],
  isLoading: false,
  isError: false,
  message: '',
};

export const quoteSlice = createSlice({
  name: 'quotes',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = '';
    },
  },
});

export const { reset } = quoteSlice.actions;
export default quoteSlice.reducer;